import type { TestId } from '@repo/test-id';
import { tr } from '@repo/locale';

import PromoCarouselSlide from '@features/promo/components/PromoCarouselSlide';

import statistics from '@assets/images/promo/statistics.webp';
import clock from '@assets/images/promo/clock.webp';

interface Props {
  testId: TestId;
}

export default function EntranceStatisticsSlide({ testId }: Props) {
  return (
    <PromoCarouselSlide
      title={tr('promo:entrance.statistics.title')}
      points={[
        { label: tr('promo:entrance.statistics.point_1') },
        { label: tr('promo:entrance.statistics.point_3'), isSoon: true },
        { label: tr('promo:entrance.statistics.point_2'), isSoon: true },
      ]}
      testId={testId}
      theme="green"
    >
      <img src={statistics} alt="" aria-hidden="true" className="absolute top-14 w-80" />
      <img src={clock} alt="" aria-hidden="true" className="absolute top-10 left-16 w-14" />
    </PromoCarouselSlide>
  );
}
